import { useImperativeHandle, forwardRef } from "react";
import { Box, Grid2 } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSkeletonLoader } from "../../../hooks/useSkeletonLoader";
import NotificationSettings from "../../../types/notificationSettings";
import FormRadio from "../../forms/FormRadio";

interface FormProps {
  onSave: SubmitHandler<NotificationSettings>;
}

export type PushFormSubmitHandler = () => void;

const PushNotifications = forwardRef<PushFormSubmitHandler, FormProps>(
  (props, ref) => {
    const { onSave } = props;

    const { handleSubmit, control } = useForm<NotificationSettings>({
      mode: "onChange",
      defaultValues: {
        siteNotifications: true,
      },
    });

    const { loadWithSkeleton } = useSkeletonLoader(false);

    useImperativeHandle(ref, () => handleSubmit(onSave));

    return (
      <Box display="flex" flexDirection="row" width="100%" height="100%">
        <Box display="flex" flexDirection="column" width="100%">
          <form>
            <Grid2 container spacing={2} marginBottom={3}>
              <Grid2 size={{ xs: 12, sm: 6 }}>
                {loadWithSkeleton(
                  <FormRadio
                    label="Enable Site Notifications"
                    control={control}
                    fieldName={`siteNotifications`}
                  />
                )}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }}>
                {loadWithSkeleton(
                  <FormRadio
                    label="Enable Text Messaging"
                    control={control}
                    fieldName="textNotifications"
                  />
                )}
              </Grid2>
            </Grid2>
          </form>
        </Box>
      </Box>
    );
  }
);

export default PushNotifications;
